import { render, staticRenderFns } from "./batch-sign-step.vue?vue&type=template&id=2b392396&scoped=true&"
import script from "./batch-sign-step.vue?vue&type=script&lang=js&"
export * from "./batch-sign-step.vue?vue&type=script&lang=js&"
import style0 from "./batch-sign-step.vue?vue&type=style&index=0&id=2b392396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b392396",
  null
  
)

export default component.exports